import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../components/Navbar/NavBar';

const Hero = () => {
    return (
        <>
            <div className="hero relative" data-aos="fade-up">
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="absolute top-0 left-0 w-full h-full object-cover z-0"
                >
                    <source src="/videos/hero-video.mp4" type="video/mp4" />
                </video>

                <div className="relative z-10">
                    <NavBar />
                </div>
            </div>
        </>
    );
};

export default Hero;